import React, { useEffect } from "react";
import { useState } from "react";
import Footer from "../../../MyComponents/Footer";
import GuestNav from "../../../MyComponents/Navbars/GuestNav";
import Hero2 from "../../../MyComponents/Hero2";
import heroContent from "../HeroContent";
import leftimg from "../../../assets/CommSkillsLeftImg.png";
import rightimg from "../../../assets/CommSkillsRightImg.png";
import CourseTimeline from "../../../MyComponents/CourseTimeline";
import Benefits from "../../../MyComponents/Benefits";
import commBenefitsImg1 from "../../../assets/commBenefitsImg1.png";
import commBenefitsImg2 from "../../../assets/commBenefitsImg2.png";
import commBenefitsImg3 from "../../../assets/commBenefitsImg3.png";
import commBenefitsImg4 from "../../../assets/commBenefitsImg4.png";
import commBenefitsImg5 from "../../../assets/commBenefitsImg5.png";
import commBenefitsImg6 from "../../../assets/commBenefitsImg6.png";
import commBenefitsImg7 from "../../../assets/commBenefitsImg7.png";
import commBenefitsImg8 from "../../../assets/commBenefitsImg8.png";
import commBenefitsImg9 from "../../../assets/commBenefitsImg9.png";
import FunActivities from "../../../MyComponents/FunActivities";
import commFunActivitiesImg1 from "../../../assets/commFunActivitiesImg1.png";
import commFunActivitiesImg2 from "../../../assets/commFunActivitiesImg2.png";
import commFunActivitiesImg3 from "../../../assets/commFunActivitiesImg3.png";
import commFunActivitiesImg4 from "../../../assets/commFunActivitiesImg4.png";
import commFunActivitiesImg5 from "../../../assets/commFunActivitiesImg5.png";
import LearningStyle from "../../../MyComponents/LearningStyle";
import VideoSection from "../../../MyComponents/VideoSection";
import Testimonials from "../../../MyComponents/Testimonials";
import FAQs from "../../../MyComponents/FooterPages/newfaq";

const CommunicationSkillsCoursePortal = () => {
  const CommunicationSkillsCoursePage =
    heroContent.communicationSkillsCoursePage;

  const Modules = [
    {
      title: "Module 1",
      activities: "06",
      classes: "06",
      description:
        "Grammar-Lean grammar rules to improve sentence structure and clarity in writing and speech.",
    },
    {
      title: "Module 2",
      activities: "06",
      classes: "06",
      description:
        "Listening-Enhance listening through real-life scenarios to improve comprehension and response skills.",
    },
    {
      title: "Module 3",
      activities: "10",
      classes: "10",
      description:
        "Speaking- Build confidence in verbal communication, public speaking, and engaging conversations.",
    },
    {
      title: "Module 4",
      activities: "05",
      classes: "05",
      description:
        "Reading-Improve reading comprehension, critical thinking, and understanding of various text's.",
    },
    {
      title: "Module 5",
      activities: "06",
      classes: "06",
      description:
        "Writing-Strengthen writing skills for essays, reports. emaits and creative content.",
    },
  ];

  const benefitsData = [
    {
      title: "Build Confidence",
      description: "Help kids express themselves clearly and confidently.",
      icon: commBenefitsImg1,
    },
    {
      title: "Improve Listening",
      description: "Teach active listening for better understanding.",
      icon: commBenefitsImg2,
    },
    {
      title: "Speak Effectively",
      description: "Enhance pronunciation and public speaking skills.",
      icon: commBenefitsImg3,
    },
    {
      title: "Boost Social Skills",
      description: "Develop empathy and conflict resolution.",
      icon: commBenefitsImg4,
    },
    {
      title: "Presentation Skills",
      description: "Introduce basic public speaking techniques.",
      icon: commBenefitsImg5,
    },
    {
      title: "Body Language",
      description: "Teach the power of non-verbal cues.",
      icon: commBenefitsImg6,
    },
    {
      title: "Storytelling",
      description: "Build engaging narrative activities.",
      icon: commBenefitsImg7,
    },
    {
      title: "Digital Communication",
      description: "Teach respectful online interaction.",
      icon: commBenefitsImg8,
    },
    {
      title: "Critical Thinking",
      description: "Develop reasoning and logical expression.",
      icon: commBenefitsImg9,
    },
  ];
  const activitiesData = [
    {
      title: "Comprehension",
      image: commFunActivitiesImg1,
    },
    {
      title: "Essay",
      image: commFunActivitiesImg2,
    },
    {
      title: "MCQ",
      image: commFunActivitiesImg3,
    },
    {
      title: "Lisening",
      image: commFunActivitiesImg4,
    },
    {
      title: "Speaking",
      image: commFunActivitiesImg5,
    },
  ];

  const videoData = {
    title: "Watch Our Introduction Video",
    description:
      "Discover how our Brain Train Abacus Course can enhance your child's cognitive skills, memory, and concentration! Our video walks you through the exciting features of the course, the benefits of learning abacus, and how it can unlock your child's full potential.\n\nClick play and learn how we make learning fun, engaging, and effective for young minds.",
    videoSrc: "", // Replace with the actual video URL
  };

  return (
    <>
      <GuestNav />
      <Hero2
        titlePart1={CommunicationSkillsCoursePage.titlePart1}
        titlePart2={CommunicationSkillsCoursePage.titlePart2}
        description={CommunicationSkillsCoursePage.description}
        buttonText={CommunicationSkillsCoursePage.buttonText}
        leftImage={leftimg}
        rightImage={rightimg}
      />
      <CourseTimeline title1="Course Structure & Syllabus" modules={Modules} />
      <Benefits
        title="How Students Can Benefit From Communication Skills"
        benefitsData={benefitsData}
      />
      <FunActivities
        mainTitle="Learn Communication Skills"
        subTitle="With 40+ Fun Activities"
        activities={activitiesData}
      />
      <LearningStyle />
      <VideoSection
        title={videoData.title}
        description={videoData.description}
        videoSrc={videoData.videoSrc}
      />
      <Testimonials />
      <FAQs />
      <Footer />
    </>
  );
};
export default CommunicationSkillsCoursePortal;
